export default __webpack_public_path__ + "static/media/team-7.19db9185.png";